
import * as React from 'react';
import {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import Formatter from "../../../util/formatter";
import {
    Button
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import AgyleDialog from "../../../components/modal/agyleDialog";
import useOpenState from "../../../hooks/useOpenState";
import Hl7Messages from "./../hl7/hl7_messages_comp";
import {ColumnTypes} from "./../hl7/hl7_messages_comp";
import ColumnsManager, {getColumns} from "./../hl7/columns_manager";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import {useSelector} from "react-redux";
import {agylePref} from "../../../store/reducers/preferences";
import _ from "lodash";
import DocsTable from './docs_table';
import DocsTableSum from './docs_table_summary';


const DocReportsSum =  forwardRef((props, ref) => {

    const {t} = useTranslation();
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);

    const [selectedRow, setSelectedRow] = React.useState(null);

    const [detailsModalIsVisible, setDetailsModalIsVisible] = useState(false);
    const [detailsMessage, setDetailsMessage] = useState(null);
    const tableRef = React.useRef(null);
    useImperativeHandle(ref, () => ({
        exportCsv: () => {
            return tableRef.current.exportCsv();
        },
    }));
    const openMessageDetails = (message) => {
        setDetailsMessage(message)
        setDetailsModalIsVisible(true);
    }

    const agylePreference = useSelector(agylePref);
    const [columns, setColumns] = React.useState([])

    useEffect(()=>{
        setColumns(getColumns(columnsInit, agylePreference?.inMessageColumnOrder));
    },[agylePreference]);

    const openJsonModal = (row) => {
        if(row.message) {
            setSelectedRow(row)
            openModal();
        } else {

        }
    }


    const columnsInit = [
        {
            name: 'procedure',
            order: 1,
            value: 'procedure',
            type: ColumnTypes.TEXT,
            description: 'Procedure',
            minWidth: 30
        },
        {
            name: 'patients',
            order: 1,
            value: 'patients',
            type: ColumnTypes.TEXT,
            description: 'No. Of Viewed Patients',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'images',
            order: 1,
            value: 'images',
            type: ColumnTypes.TEXT,
            description: 'No of Images/Report',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'location',
            order: 1,
            value: 'location',
            type: ColumnTypes.TEXT,
            description: 'Capture location',
            minWidth: 10,
            maxWidth: 175
        }
    ];




    const handleCloseMessageDetails = () =>{
        setDetailsModalIsVisible(false);
    }


    const getMessage = (row) => {
        return row.message
    }

    const sortColumn = () => {
        const filteredColumns = _.filter(columns, col => {
            return !_.isNil(col.order);
        });

        return _.sortBy(filteredColumns, obj => {
            return obj.order;
        });
    };


    const [openConfig, setOpenConfig] = React.useState(false);

    return (<div>

        {/*<IconButton*/}
        {/*    size={"small"}*/}
        {/*    disableRipple={true}*/}
        {/*    onClick={() => setOpenConfig(true)}>*/}
        {/*    <SettingsIcon/>*/}
        {/*</IconButton>*/}

        <ColumnsManager prefPath={"inMessageColumnOrder"}
                        columns = {columns}
                        title={"Incoming Messages Columns Settings"}
                        columnsInit = {columnsInit}
                        openConfig={openConfig}
                        closeModal={() => setOpenConfig(false)}/>

        <DocsTableSum ref={tableRef}  table = {"hl7Log"} openColumnManager={() => setOpenConfig(true)} webSocketChanel = {"TODODocReportsSum"} columns={sortColumn()} messagePath={getMessage} {...props}/>
    </div>);
})

export default DocReportsSum;